// frontend/src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './styles/globals.css';
import './utils/axiosConfig';
import App from './App';
import { initializeAuth } from './utils/auth';

// تهيئة التوكن عند بدء التطبيق
initializeAuth();

const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement);

// ✅ إضافة class لإخفاء المحتوى الثابت بعد تحميل React
//document.documentElement.classList.add('react-loaded');

// ✅ تعطيل StrictMode في Production لمنع الاتصالات المكررة
const isDevelopment = process.env.NODE_ENV === 'development';

const AppWrapper = (
  <BrowserRouter
    future={{
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    }}
  >
    <App />
  </BrowserRouter>
);

root.render(
  isDevelopment ? (
    <React.StrictMode>
      {AppWrapper}
    </React.StrictMode>
  ) : (
    AppWrapper
  )
);